import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import formScaffolding from 'components/searchAds/mappers/formScaffolding';
import withRestProps from 'helpers/withRestProps';
import * as actions from './actions';
import createMapStateToProps from './mapStateToProps';
import Form from './Form';

export default function withSearchWidget(params = {}) {
  const { form, validate } = params;
  const mapStateToProps = createMapStateToProps(form);

  return function withSearchAdsAmount(WrappedComponent) {
    class SearchWidget extends PureComponent {
      static propTypes = {
        applyFilters: PropTypes.func.isRequired,
        navigateToSearchWithExtraFilters: PropTypes.func.isRequired,
        onSubmit: PropTypes.func,
        searchLink: PropTypes.string,
        searchLinkExtra: PropTypes.string,
        rest: PropTypes.object,
      };

      state = {
        error: null,
        isFormTouched: false,
        isLoaded: false,
        isLoading: false,
      };

      handleFormChange = () => {
        this.setState({ isFormTouched: true });
      };

      handleApplyFilters = () => {
        const { isFormTouched } = this.state;

        this.props.applyFilters(form, { applyDefaultSort: isFormTouched });
      };

      handleNavigateToSearchWithExtraFilters = () => {
        const { isFormTouched } = this.state;

        this.props.navigateToSearchWithExtraFilters(form, {
          applyDefaultSort: isFormTouched,
        });
      };

      render() {
        const { onSubmit, rest, searchLink, searchLinkExtra } = this.props;

        return (
          <Form
            enableReinitialize
            form={form}
            initialValues={formScaffolding}
            onChange={this.handleFormChange}
            onSubmit={onSubmit}
            validate={validate}
          >
            {(props) => (
              <WrappedComponent
                {...rest}
                {...props}
                {...this.state}
                formName={form}
                applyFilters={this.handleApplyFilters}
                navigateToSearchWithExtraFilters={
                  this.handleNavigateToSearchWithExtraFilters
                }
                searchLink={searchLink}
                searchLinkExtra={searchLinkExtra}
              />
            )}
          </Form>
        );
      }
    }

    return connect(mapStateToProps, actions)(withRestProps()(SearchWidget));
  };
}
